import { ApplicationLocation, ApplicationMethod } from "@lib/analyticsTypes";
import { clarityFireApplicationEvent } from "@lib/clarityEvents";
import { fetchDistinctId } from "@lib/posthogEvents";
import { query, queryID } from "@stores/searchQuery";
import { actions } from "astro:actions";
import aa from "search-insights";
import { get } from "svelte/store";

//This is needed to personalize the recommendations
export async function handleUserToggleJobOfferLikeTracking(
	params: {
		objectID: string;
		afterSearch?: {
			positions: number;
		};
		isLiked: boolean;
	},
	fc?: () => void
) {
	fc?.();

	//we only want to track if user likes something
	if (params.isLiked) return;
	if (
		get(query) &&
		params.afterSearch?.positions !== undefined &&
		params.afterSearch.positions > -1
	) {
		aa("clickedObjectIDsAfterSearch", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			eventName: "Job Offer Liked",
			objectIDs: [params.objectID],
			queryID: get(queryID),
			positions: [params.afterSearch.positions + 1]
		});
	} else {
		aa("clickedObjectIDs", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			eventName: "Job Offer Liked",
			objectIDs: [params.objectID]
		});
	}
}

export function handleUserJobOfferApplyTracking(
	params: {
		bypassPostHog?: boolean;
		objectID: string;
		company_uuid: string;
		application_method: ApplicationMethod;
		application_location: ApplicationLocation;
	},
	fc?: () => void
) {
	fc?.();
	if (get(query)) {
		aa("convertedObjectIDsAfterSearch", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			queryID: get(queryID),
			eventName: "User Applied",
			objectIDs: [params.objectID]
		});
	} else {
		aa("convertedObjectIDs", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			eventName: "User Applied",
			objectIDs: [params.objectID]
		});
	}

	//Means the apply is handled server side
	if (!params.bypassPostHog) {
		// Fetch the distinct_id of the current PostHog user.
		const distinct_id = fetchDistinctId();
		if (distinct_id) {
			try {
				actions.analytics.captureApplicationEvent({
					distinct_id,
					job_uuid: params.objectID,
					company_uuid: params.company_uuid,
					application_method: params.application_method,
					application_location: params.application_location
				});
			} catch (e) {
				console.error(e);
			}
		}
	}

	clarityFireApplicationEvent(
		params.objectID,
		params.company_uuid,
		params.application_method,
		params.application_location
	);
}

//Improve search results ranking based on click through rates per position
export function handleUserJobOfferNavigateToFanpageTracking(
	params: {
		objectID: string;
		afterSearch?: {
			positions: number;
		};
	},
	fc?: () => void
) {
	fc?.();
	//track after search if user actually performed a search
	if (
		get(query) &&
		params.afterSearch?.positions !== undefined &&
		params.afterSearch.positions > -1
	) {
		aa("clickedObjectIDsAfterSearch", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			eventName: "Fanpage Navigated",
			objectIDs: [params.objectID],
			queryID: get(queryID),
			positions: [params.afterSearch.positions + 1]
		});
	} else {
		aa("clickedObjectIDs", {
			index: import.meta.env.PUBLIC_ALGOLIA_INDEX_NAME || "",
			eventName: "Fanpage Navigated",
			objectIDs: [params.objectID]
		});
	}
}
